import { Chip, Container, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import "react-multi-carousel/lib/styles.css";
import { getAllBlogs } from "../../services/blogsFn";
import BlogsCard from "../../components/cards/BlogsCard";
import BlogsCardSkeleton from "../../components/skeletons/BlogCardSkeleton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { fetchBlogs } from "../../lib/redux/slices/blogSlice";
import { useDispatch, useSelector } from "react-redux";
import { setHasFetchedEcommerce } from "../../lib/redux/slices/searchKeysSlice";

const EcommerceBlogs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    data: blogs,
    isLoading,
    error,
  } = useSelector((state) => state.blogReducer);
  const { hasFetchedEcommerce } = useSelector(
    (state) => state.searchKeysReducer.searchKeys
  );
  const containerRef = useRef(null); // For observing visibility

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !hasFetchedEcommerce) {
          dispatch(fetchBlogs("ecommerce"));
          dispatch(setHasFetchedEcommerce(true));
        }
      },
      {
        threshold: 0.3, // fire when 30% of component is visible
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [hasFetchedEcommerce]);

  return (
    <Container ref={containerRef} maxWidth="lg" sx={{ py: 4 }}>
      <Stack textAlign={"center"} mb={5}>
        <Typography variant="heading_pr" component={"h1"}>
          {t("ecommerceBlogs")}
        </Typography>
        <Typography variant="heading_sec" component={"p"}>
          {t("ecommerceBlogsDesc")}
        </Typography>
      </Stack>

      {blogs.length > 2 && isLoading === false && (
        <Stack alignItems={"flex-end"} mb={2}>
          <Chip
            icon={<VisibilityIcon />}
            label={t("viewAll")}
            size="small"
            color="primary"
            onClick={() => navigate("/blogs")}
          />
        </Stack>
      )}

      <Grid container spacing={2}>
        {isLoading
          ? Array.from({ length: 3 }).map((_, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <BlogsCardSkeleton />
              </Grid>
            ))
          : blogs.map((blog) => (
              <Grid item xs={12} sm={6} md={4} key={blog._id || blog.id}>
                <BlogsCard blogData={blog} />
              </Grid>
            ))}
      </Grid>
    </Container>
  );
};

export default EcommerceBlogs;
